module.exports = __webpack_public_path__ + "img/foto_14.7427f71a.png";